import { useState } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import ImageMagnifier from "../../UI/ImageMagnifier/ImageMagnifier";
import ImagePlaceholder from "../../UI/ImagePlaceholder/ImagePlaceholder";
import classes from "./SkuBundleImages.module.css";

const SkuBundleImages = (props) => {
  const { images, name } = props;
  const [currentSelectedImageIndex, setCurrentSelectedImageIndex] = useState(0);

  const currentImageChangedHandler = (index) => {
    setCurrentSelectedImageIndex(index);
  };

  return (
    <div className={classes["images"]}>
      <ul className={classes["images__list"]}>
        {images.slice(0, 3).map((image, index) => (
          <li
            key={index}
            className={classNames(classes["images__list-item"], {
              [classes["images__list-item--active"]]:
                index === currentSelectedImageIndex,
            })}
          >
            <button
              className={classes["images__list-item-btn"]}
              onClick={() => currentImageChangedHandler(index)}
            >
              <ImagePlaceholder
                src={image}
                alt={name}
                className={classes["images__list-item-img"]}
              />
            </button>
          </li>
        ))}
      </ul>
      <div className={classes["images__current-img-wrapper"]}>
        <ImageMagnifier src={images[currentSelectedImageIndex]} alt={name} />
      </div>
    </div>
  );
};

export default SkuBundleImages;

SkuBundleImages.propTypes = {
  images: PropTypes.arrayOf(PropTypes.string).isRequired,
  name: PropTypes.string,
};
